import React from 'react';
import styles from './MainNav.module.scss';
import cn from 'classnames';
import { Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { links } from '../../constants/links';
import useTransportPermitsMatch from '../../hooks/useTransportPermitsMatch';
import useGetMenu from '../../hooks/useGetMenu';

const { Item } = Menu;

const MainNav = ({ className }) => {
  const location = useLocation();
  const { pathname } = location;

  const match = useTransportPermitsMatch();

  const menu = useGetMenu();

  const urlCompanyId = match?.params.companyId
    ? Number(match.params.companyId)
    : null;

  const activeKey = menu.find((item) => pathname.includes(item.key))?.key;

  return (
    <Menu
      className={cn(styles.root, className)}
      selectedKeys={[activeKey]}
      mode="horizontal"
    >
      {menu.map((item) => (
        <Item key={item.key}>
          <Link
            to={{
              pathname: `${links.rootWithCompany}/${urlCompanyId}/${item.key}`,
            }}
          >
            {item.content}
          </Link>
        </Item>
      ))}
    </Menu>
  );
};

export default MainNav;
